// removed by extract-text-webpack-plugin
module.exports = {"legend":"StackedBarChart__legend___1kNSX","hiddenElement":"StackedBarChart__hiddenElement___3mKaj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StackedBarChart/StackedBarChart.less
// module id = 1242
// module chunks = 0